// extracted by mini-css-extract-plugin
export default {"sortIcon":"DateTable_sortIcon__uSxiD","parentDataGridContainer":"DateTable_parentDataGridContainer__XBHCv"};